import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MSpinner } from 'components/Shared';
import ComparableDetails from 'components/Appraiser/ComparableDetails';

class Comparable extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.props.getComparableDetails(params.token);
  }

  render() {
    const {
      isFetching,
      details
    } = this.props;

    return (
      <div className="case-header md-grid">
        {isFetching || !details ? <MSpinner /> : <ComparableDetails details={details} />}
      </div>
    );
  }
}

Comparable.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  details: PropTypes.object.isRequired,
  getComparableDetails: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired
};
export default Comparable;

